import styles from './AdminCardFamilyMember.module.css';
import iconOptions from '../../../../assets/img/icons/icon-menu-options.png';
import { Link } from 'react-router-dom';
import { utils } from '../../../../utils';
import config from '../../../../../config';
import { useState, useRef, useEffect } from 'react';
import { RelationshipData } from '../../interface/RelationshipData';

interface AdminCardFamilyMemberProps {
    relationshipData: RelationshipData;
    onDelFamilyModal: (family: any) => void;
}

export const AdminCardFamilyMember = ({ relationshipData, onDelFamilyModal }: AdminCardFamilyMemberProps) => {
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && 
                buttonRef.current && 
                !menuRef.current.contains(event.target as Node) && 
                !buttonRef.current.contains(event.target as Node)) {
                setShowMenu(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const onCloseMenu = () => {
        setShowMenu(false);
    }

    const onOpenMenu = () => {
        setShowMenu(true);
    }

    const onDelFamily = () => {
        onDelFamilyModal(relationshipData);
        onCloseMenu();
    }

    return (
        <div className={styles.card}>
            <div className={styles.card__options}>
                <img 
                    ref={buttonRef}
                    src={iconOptions} 
                    className={styles.options__icon} 
                    onClick={onOpenMenu} 
                />

                {showMenu && (
                    <div ref={menuRef} className={`${styles.options__menu}`}>
                        <div className={`${styles.options__item} ${styles.options__item_delete}`} onClick={onDelFamily}>
                            Eliminar
                        </div>
                        <div className={`${styles.options__item} ${styles.options__item_cancel}`} onClick={onCloseMenu}>
                            Cancelar
                        </div>
                    </div>
                )}
            </div>
            <div className={styles.card__header}>
                <div className={styles.card__avatar}>
                    <img
                        alt="Avatar"
                        className={styles.avatar__img}
                        src={relationshipData.family_patient.image_store_id ? utils.getImagenBase64(relationshipData.family_patient.image_store_id) : 'https://ng-backend.indisa.cl/app/uploads/2022/08/Avatar-hombre-1.jpg'}

                    />
                </div>
                <h3 className={styles.card__name}>{relationshipData.family_patient.first_name} {relationshipData.family_patient.last_name}</h3>
            </div>

            <div className={styles.card__info}>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>Relación</p>
                    <p className={styles.info__value}>{relationshipData.type_relationship.name}</p>
                </div>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>{relationshipData.family_patient.document_type.name}</p>
                    <p className={styles.info__value}>{relationshipData.family_patient.document_number}</p>
                </div>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>Email</p>
                    <p className={styles.info__value}>{relationshipData.family_patient.email}</p>
                </div>
                <div className={styles.info__item}>
                    <p className={styles.info__label}>Teléfono</p>
                    <p className={styles.info__value}>{relationshipData.family_patient.phone}</p>
                </div>
            </div>
        </div>
    )
}
